import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-logged_out_submission-click';
/**
 * Submit ticket through contact us with logged out user
 */
export function trackCxFoundationsLoggedOutSubmissionClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
